var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Map as MapboxMap, LngLat as MapboxLngLat } from 'mapbox-gl';
import { GradElevationControl, GradGridControl } from '.';
import { ArmaGridFormat, fetchMapMetaData } from '..';
import { relativeUrl } from '../utils';
import 'mapbox-gl/dist/mapbox-gl.css';
import { armaToLatLng, latLngToArma } from '../coords';
var GradMap = /** @class */ (function (_super) {
    __extends(GradMap, _super);
    function GradMap(map, options) {
        var _this = _super.call(this, __assign({ style: relativeUrl(map + "/mvt/style.json"), renderWorldCopies: false }, options)) || this;
        _this._armaMapMetaData = null;
        _this._satShown = false;
        _this._loadElevation = false;
        _this._gridShown = true;
        _this._gridControl = null;
        _this._elevationControl = null;
        _this._grid = {
            gridStart: [0, 0],
            stepX: 100,
            stepY: 100,
            formatX: new ArmaGridFormat('000'),
            formatY: new ArmaGridFormat('000'),
            format: 'XY',
        };
        // disable map rotation using right click + drag
        _this.touchZoomRotate.disableRotation();
        // disable map rotation using touch rotation gesture
        _this.dragRotate.disable();
        _this._armaMapName = map;
        if (options.satShown !== undefined)
            _this._satShown = options.satShown;
        if (options.gridShown !== undefined)
            _this._gridShown = options.gridShown;
        if (options.loadElevation !== undefined)
            _this._loadElevation = options.loadElevation;
        var mapMetaPromise = fetchMapMetaData(_this._armaMapName)
            .then(function (meta) { _this._armaMapMetaData = meta; })
            .catch(function (e) {
            if (e.type === 'GradResponseError') {
                var err = e;
                if (err.response.status === 404)
                    _this.fire('error:mapnotfound');
            }
            _this.fire('error', e);
        });
        _this.on('load', function () {
            // add satellite source
            _this.addSource('satellite', {
                type: 'raster',
                url: relativeUrl(_this._armaMapName + "/sat/tile.json")
            });
            // add satellite layer
            if (_this.satShown) {
                var layers = _this.getStyle().layers;
                _this.addLayer({
                    id: 'satellite',
                    type: 'raster',
                    source: 'satellite',
                    paint: { 'raster-opacity': 0.8 },
                }, layers !== undefined && layers.length > 1 ? layers[1].id : undefined);
            }
            ;
            // elevation control
            _this._elevationControl = new GradElevationControl(_this._armaMapName);
            if (_this._loadElevation)
                _this.addControl(_this._elevationControl);
            mapMetaPromise.then(function () { _this.fire('grad-load'); });
        });
        _this.on('grad-load', function () {
            if (_this._armaMapMetaData === null)
                return;
            var _a = _this._armaMapMetaData, gridOffsetX = _a.gridOffsetX, gridOffsetY = _a.gridOffsetY, worldSize = _a.worldSize, grids = _a.grids;
            // add grid control
            _this._gridControl = new GradGridControl(gridOffsetX, gridOffsetY, worldSize, grids);
            if (_this._gridShown)
                _this.addControl(_this._gridControl);
            // find grid for all the way zoomed in
            var grid = grids.sort(function (a, b) { return a.zoomMax - b.zoomMax; })[0];
            _this._grid = {
                gridStart: [gridOffsetX, worldSize - gridOffsetY],
                stepX: grid.stepX,
                stepY: -grid.stepY,
                formatX: new ArmaGridFormat(grid.formatX),
                formatY: new ArmaGridFormat(grid.formatY),
                format: grid.format
            };
        });
        return _this;
    }
    Object.defineProperty(GradMap.prototype, "satShown", {
        get: function () {
            return this._satShown;
        },
        set: function (value) {
            this._satShown = value;
            if (value) {
                var layers = this.getStyle().layers;
                this.addLayer({
                    id: 'satellite',
                    type: 'raster',
                    source: 'satellite',
                    paint: { 'raster-opacity': 0.8 },
                }, layers !== undefined && layers.length > 1 ? layers[1].id : undefined);
            }
            else {
                this.removeLayer('satellite');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GradMap.prototype, "gridShown", {
        get: function () {
            return this._gridShown;
        },
        set: function (value) {
            this._gridShown = value;
            if (this._gridControl === null)
                return;
            if (value) {
                this.addControl(this._gridControl);
            }
            else {
                this.removeControl(this._gridControl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GradMap.prototype, "loadElevation", {
        get: function () {
            return this._loadElevation;
        },
        set: function (value) {
            this._loadElevation = value;
            if (this._elevationControl === null)
                return;
            if (value) {
                this.addControl(this._elevationControl);
            }
            else {
                this.removeControl(this._elevationControl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GradMap.prototype, "armaMapMetaData", {
        get: function () {
            return this._armaMapMetaData;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Project Arma to lat/lng
     * @param {[number, number]} pos Arma position as [x, y]
     * @returns {MapboxLngLat} LngLat
     */
    GradMap.prototype.fromArma = function (pos) {
        if (this._armaMapMetaData === null) {
            throw new Error('GradMap not fully initialized. Try calling this function after the "grad-init" event has fired');
        }
        var _a = __read(armaToLatLng(this._armaMapMetaData.worldSize, pos), 2), lat = _a[0], lng = _a[1];
        return new MapboxLngLat(lng, lat);
    };
    /**
     * Project lat/lng to Arma
     * @param {MapboxLngLat} lngLat LngLat
     * @returns {[number, number]} Arma position as [x, y]
     */
    GradMap.prototype.toArma = function (lngLat) {
        if (this._armaMapMetaData === null) {
            throw new Error('GradMap not fully initialized. Try calling this function after the "grad-init" event has fired');
        }
        return latLngToArma(this._armaMapMetaData.worldSize, [lngLat.lat, lngLat.lng]);
    };
    /**
     * Returns the map grid position of an position.
     * This does basically the same as the [mapGridPosition scripting command](https://community.bistudio.com/wiki/mapGridPosition).
     * @param {[number, number]} position Arma position as [x, y]
     * @returns {string} Formatted grid
     */
    GradMap.prototype.posToGrid = function (_a) {
        var _b = __read(_a, 2), x = _b[0], y = _b[1];
        if (this._armaMapMetaData === null) {
            throw new Error('GradMap not fully initialized. Try calling this function after the "grad-init" event has fired');
        }
        var _c = this._grid, gridStart = _c.gridStart, format = _c.format, formatX = _c.formatX, formatY = _c.formatY, stepX = _c.stepX, stepY = _c.stepY;
        var xIndex = Math.floor((x - gridStart[0]) / stepX);
        var yIndex = Math.floor((y - gridStart[1]) / stepY);
        var xStr = formatX.formatGridNumber(xIndex);
        var yStr = formatY.formatGridNumber(yIndex);
        return format.replace('X', xStr).replace('Y', yStr);
    };
    /**
     * Get elevation of position.
     * @param {MapboxLngLat} lngLat LngLat
     * @returns {number} Elevation (-1 if elevation could not be calculated)
     */
    GradMap.prototype.getElevation = function (lngLat) {
        if (!this._loadElevation) {
            throw new Error('getElevation only works, when loadElevation is set to true.');
        }
        if (this._elevationControl === null)
            return -1;
        return this._elevationControl.getElevation(lngLat);
    };
    return GradMap;
}(MapboxMap));
export default GradMap;
